import script from "./NewsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsScreen.vue?vue&type=script&setup=true&lang=js"

import "./NewsScreen.vue?vue&type=style&index=0&id=6deb559a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6deb559a"]])

export default __exports__